import { Box, 
  // Button,
   ButtonGroup, withStyles } from "@material-ui/core";
import React, { FormEvent } from "react";
import Component from "src/components/Component";
import withAxios from "src/components/withAxios";
import { ISeasonData } from "src/services";
import { getAdminApi } from "../../seasonsPage/utils/getAdminApi/getAdminApi";
import { EditSeasonsModal } from "./components/edit-seasons-modal/EditSeasonsModal";
// import {
//   OPEN_ADD_SEASON_MODAL_BUTTON_LABEL,
//   OPEN_EDIT_SEASONS_MODAL_BUTTON_LABEL,
//   OPEN_RESET_SEASONS_BUTTON_LABEL,
// } from "./constants";
import { IProps, ISeasonsPageState } from "./types";
import { AddSeasonModal } from "./components/add-season-modal/AddSeasonModal";
import { styles } from "./styles";

export default withStyles(styles)(
  withAxios(
    class extends Component<IProps, ISeasonsPageState> {
      public readonly state = this.buildState({
        isAddSeasonModalOpen: false,
        isEditSeasonsModalOpen: false,
        seasonName: "",
        seasonStartDate: new Date(),
      });

      private readonly handleSeasonNameChange = this.stateInputEventHandler(
        (v) => ({ seasonName: v })
      );

      public render() {
        const {
          // classes,
          defaultSeasons,
          schoolId,
          seasons,
          loadingSeasonsResponse,
          loadSeasons,
          // openDefaultSettingsModal,
          setSeason,
          seasonsChange,
        } = this.props;
        const { seasonName, seasonStartDate, submitting } = this.state;

        // const handleOpenAddSeasonModal = () =>
        //   this.setState({ isAddSeasonModalOpen: true });
        const handleCloseAddSeasonModal = () =>
          this.setState({ isAddSeasonModalOpen: false });

        // const handleOpenEditSeasonModal = () =>
        //   this.setState({ isEditSeasonsModalOpen: true });
        const handleCloseEditSeasonModal = () =>
          this.setState({ isEditSeasonsModalOpen: false });

        const handleDayClick = (day: Date) =>
          this.setState({ seasonStartDate: day });

        const hasCustomSeasons = seasons.length > 0;

        return (
          <>
            <Box display="flex" gridGap="1rem">
              <ButtonGroup>
                {/* <Button
                  onClick={handleOpenAddSeasonModal}
                  variant="contained"
                  color="primary"
                >
                  {OPEN_ADD_SEASON_MODAL_BUTTON_LABEL}
                </Button> */}
                {/* {hasCustomSeasons && (
                  // <Button
                  //   onClick={handleOpenEditSeasonModal}
                  //   variant="outlined"
                  //   color="primary"
                  // >
                  //   {OPEN_EDIT_SEASONS_MODAL_BUTTON_LABEL}
                  // </Button>
                )} */}
                {/* <Button
                  className={classes.resetButton}
                  onClick={openDefaultSettingsModal}
                  variant="outlined"
                >
                  {OPEN_RESET_SEASONS_BUTTON_LABEL}
                </Button> */}
              </ButtonGroup>
            </Box>
            <AddSeasonModal
              handleSeasonNameChange={this.handleSeasonNameChange}
              handleDayClick={handleDayClick}
              isOpen={this.state.isAddSeasonModalOpen}
              onClose={handleCloseAddSeasonModal}
              onSubmit={(e: FormEvent<Element>) => {
                this.handleAddSeason(e);
              }}
              seasonName={seasonName}
              seasonStartDate={seasonStartDate}
              submitting={submitting}
            />
            {hasCustomSeasons && (
              <EditSeasonsModal
                isOpen={this.state.isEditSeasonsModalOpen}
                onClose={handleCloseEditSeasonModal}
                loadingSeasonsResponse={loadingSeasonsResponse}
                seasons={seasons}
                defaultSeasons={defaultSeasons}
                schoolId={schoolId}
                loadSeasons={loadSeasons}
                setSeason={setSeason}
                seasonsChange={seasonsChange}
              />
            )}
          </>
        );
      }

      private handleAddSeason = async (e: React.FormEvent) => {
        e.preventDefault();
        this.runCancellableStatefulAsync(
          this,
          {
            submitting: true,
          },
          {
            isAddSeasonModalOpen: false,
            seasonName: "",
            submitting: undefined,
          },
          async () => {
            const { schoolId, defaultSeasons } = this.props;
            const { seasonName, seasonStartDate } = this.state;
            await this.buildPost<ISeasonData, void>(
              this,
              `${getAdminApi(defaultSeasons)}season`
            )({
              name: seasonName.trim(),
              order: -1,
              schoolId,
              startDate: Number(seasonStartDate),
            });
            this.props.loadSeasons();
          },
          () => {
            window.alert("Failed to add sport");
            this.setState({ submitting: undefined });
          }
        );
      };
    }
  )
);



// WEBPACK FOOTER //
// ./src/pages/director/seasons/components/seasons-editor/SeasonsEditor.tsx